import axiosInstance from '../axios/axiosInstance';
import { SchoolYear } from '../model/response';

export const findAllSchoolYear = async () => {
  const { data } = await axiosInstance.get<SchoolYear[]>('school-years', { params: { fromCMS: true } });
  return data;
};
